<div class="course-list-compact">
  <app-no-results #noResults [customMessage]="true" [message]="message"></app-no-results>

  @if (courseList.length > 0) {
    @for (course of courseList; track course) {
      <a
        class="course-row"
        routerLink="/participants/courses/view-course/{{ course.courseRecordId }}">
        <div class="course-row__thumb-wrap">
          <img class="course-row__thumb" [src]="course.thumbnailUrl" alt="">
        </div>
        <div class="course-row__content">
          <span class="course-row__title">{{ course.courseName }}</span>
          <div class="course-progress course-progress--sm" [attr.aria-label]="getProgressLabel(course) + ' progress'">
            <div class="course-progress__track">
              <div class="course-progress__fill" [style.width.%]="getProgressPercent(course)"></div>
            </div>
          </div>
          <span class="course-row__status" [ngClass]="getStatusClass(course)">{{ getProgressLabel(course) }}</span>
        </div>
        <i class="fa-solid fa-chevron-right course-row__chevron" aria-hidden="true"></i>
      </a>
    }
  }
</div>
